import { Component, Inject } from '@angular/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface DialogDataQReasonExpositionTime {
  reason: string;
}
@Component({
    selector: 'app-execution-q-edit-reason-exposition-time',
    templateUrl: './execution-q-edit-reason-exposition-time.component.html',
    styleUrl: './execution-q-edit-reason-exposition-time.component.scss',
    standalone: false,
})
export class ExecutionQEditReasonExpositionTimeComponent {
  constructor(
      private dialogRef: MatDialogRef<ExecutionQEditReasonExpositionTimeComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogDataQReasonExpositionTime,
      private translate: TranslateService,
      public snackBarService: SnackBarService) { }

  onOkClick(): void {
    const errs = [];

    if (this.data.reason == null || this.data.reason === '') {
      errs.push(this.translate.instant('common.reasonChangeError'));
    }

    if (errs.length === 0) {
      this.dialogRef.close(this.data.reason);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
